import qs from 'qs';
import Vue from 'vue';
import { Component, Inject, Watch, Prop } from 'vue-property-decorator';
import OneButtonModal from '../../components/oneButtonModal';
import UnisProductModal from '../../components/unisProductModal';
import tmsService from '../../services/axios/tmsService';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import tmsTransformRequestService from '../../services/axios/tmsTransformRequestService';
import { LocalStorageCache } from '../../services/cache';
import { TMSCustomerAccountService, TMSCustomerAccountServiceEvent } from '../../services/user';
import UinsDefaultSelect from '../unisDefaultSelect';
import template from './navbar.vue';

const customerAccountService = TMSCustomerAccountService.create({
    cache: LocalStorageCache.create(),
    tmsService: tmsService,
    tmsTransformRequestService: tmsTransformRequestService,
});

@Component({
    mixins: [template],
    components: {
        OneButtonModal,
        UnisProductModal,
        UinsDefaultSelect,
    },
})
export default class NavBar extends Vue {
    @Inject('reload') readonly reload!: Function;
    @Prop({ type: Boolean, default: false }) readonly isClaimsAccess!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isSBCust!: boolean;

    isShowNotif: any = false;
    isShowUser: any = false;
    isInSearchBox: any = false;
    isShowShade: any = false;
    contactCupport: any = {
        content: '',
        pro_or_pu: '',
        type_of_inquiry: '',
    };
    billingList: Array<any> = [];
    userBilling: any = '';
    search_text: any = '';
    userName: any = localStorage.getItem('UserFirstLast');
    userNameFirstLetter: string = '';
    editProductModal: string = 'Contactsupport';
    isRouteNameRrackShipmentLoggedIn: any = false;
    IsAdmin: boolean = localStorage.getItem('IsAdmin') == '1';
    @Watch('$route')
    routechange(to: any, from: any) {
        if (to.name == 'trackShipmentLoggedIn') this.isRouteNameRrackShipmentLoggedIn = true;
        else this.isRouteNameRrackShipmentLoggedIn = false;
    }

    created() {
        this.userNameFirstLetter = this.getFirstLetterUppercase();
    }

    getFirstLetterUppercase() {
        let userName = localStorage.getItem('UserFirstLast');
        if (userName) {
            return userName.charAt(0).toUpperCase();
        } else {
            return '';
        }
    }

    onShowNotif() {
        this.isShowNotif = true;
        this.isShowUser = false;
        this.isShowShade = true;
    }

    onShowUser() {
        this.isShowNotif = false;
        this.isShowUser = true;
        this.isShowShade = true;
    }

    handleFocus() {
        this.isInSearchBox = true;
    }

    handleBlur() {
        this.isInSearchBox = false;
    }

    onShowShade() {
        this.isShowNotif = false;
        this.isShowUser = false;
        this.isShowShade = false;
    }

    logout() {
        this.$store.dispatch('logout');
    }

    async mounted() {
        (window as any).contactupport = this.contactSupport;
        this.getCustomerAccount();
        window.addEventListener(
            TMSCustomerAccountServiceEvent.BillToChanged,
            ({ detail }: CustomEvent<any>) => {
                if (this.userBilling === detail.location_id) {
                    return;
                }
                this.userBilling = detail.location_id;
            },
            false
        );
    }

    getCustomerAccount() {
        customerAccountService
            .fetchThenCacheCustomerAccount()
            .then(res => {
                this.EventBus.globalEvent('val');
                this.userBilling = res.billing.location_id ? res.billing.location_id : '';
                this.billingList = res.billing_list ? res.billing_list : [];
            })
            .catch((err: any) => {});
    }

  getWriteNewWiseRefreshLogin() {
    return customerAccountService.getWriteNewWiseRefreshLogin();
  }

    public changeBillingList(billing: any) {
        customerAccountService
            .useBillTo(billing)
            .then(res => {
                this.EventBus.globalEvent('val');

                if (res === true || res.status_code == 'success') {
                    if (this.$route.path == '/home') {
                        this.reload();
                    } else {
                        this.$router.push('/home');
                    }
                }
            })
            .catch((err: any) => {
                this.err('User switching error');
            });
    }

    contactSupport(
        data: Partial<{
            pro_or_pu: string;
        }> = {}
    ) {
        const { pro_or_pu = '' } = data;

        this.isShowNotif = false;
        this.isShowUser = false;
        this.isShowShade = false;
        this.contactCupport = {
            content: '',
            pro_or_pu: pro_or_pu,
            title: '',
            type_of_inquiry: '',
        };
        this.$modal.show(this.editProductModal);
    }

    modalHide() {
        this.isShowNotif = false;
        this.isShowUser = false;
        this.isShowShade = false;
        this.$modal.hide(this.editProductModal);
    }

    send() {
        this.isShowNotif = false;
        this.isShowUser = false;
        this.isShowShade = false;
        tmsServiceBackend
            .post(`/cpv2/support/contactSupportV2`, qs.stringify(this.contactCupport))
            .then(
                (res: any) => {
                    this.showUpdated({
                        title: 'Contact support send',
                        mag: res.data.message,
                    });
                },
                (err: any) => {
                    this.err(err.data.message);
                }
            );
        this.$modal.hide(this.editProductModal);
    }

    handleSubmit(e: any) {
        this.trackShipment();
        e.srcElement.blur();
    }

    switchToShipperPortal() {
        localStorage.setItem('IsShipperOrConsignee', '1');
        localStorage.setItem('switchToShipperPortal', '0');
        window.location.href = 'index.html#/shipments-4-shippers';
    }

    trackShipment() {
        if (!this.userBilling) return;
        if (!this.search_text) {
            this.err('Please enter BOL, PRO, PU or PO');
            return;
        }
        this.$router.replace({
            name: 'trackShipmentLoggedIn',
            query: {
                searchText: this.search_text,
            },
        });
    }

    get hasClaimsRestriction() {
        return this.isClaimsAccess && this.isSBCust;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/navbar/index.ts